import Inputmask from "inputmask";

export function inputMask() {
    if (jQuery('.input-mask').length) {
        var im = new Inputmask("999-999-9999", {
            showMaskOnHover: false,
            showMaskOnFocus: true,
            removeMaskOnSubmit: true
        });

        var imEmail = new Inputmask({
            alias: "email",
        }, {
            showMaskOnHover: false,
            showMaskOnFocus: true
        });

        var imDate = new Inputmask("99/99/9999", {
            alias: "datetime",
            inputFormat: "mm/dd/yyyy"
        }, {
            showMaskOnHover: false,
            showMaskOnFocus: true
        });

        // Generic phone mask
        var $phoneSelector = jQuery('.telephone-mask');
        if ($phoneSelector != null) {
            im.mask($phoneSelector);
        }

        // Generic email mask
        var $emailSelector = jQuery('.email-mask');
        if ($emailSelector != null) {
            imEmail.mask($emailSelector);
        }

        // Generic email mask
        var $dateSelector = jQuery('.date-mask');
        if ($dateSelector != null) {
            imDate.mask($dateSelector);
        }
        

        if (document.getElementById('billing:telephone') != null) {
            var phoneBilling = document.getElementById("billing:telephone");
            im.mask(phoneBilling);
        }
        if (document.getElementById('shipping:telephone') != null) {
            var phoneShipping = document.getElementById("shipping:telephone");
            im.mask(phoneShipping);
        }

        if (document.getElementById('am_giftcard_sender_email') != null) {
            var senderEmail = document.getElementById("am_giftcard_sender_email");
            imEmail.mask(senderEmail);
        }

        if (document.getElementById('am_giftcard_recipient_email') != null) {
            var senderEmail = document.getElementById("am_giftcard_recipient_email");
            imEmail.mask(senderEmail);
        }
    }
}